/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Mic = ({ color = 'forest', height = 16, width = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${height} ${width}`}
      sx={{ fill: color }}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4 8.8696C14.4 9.3112 14.1064 9.6 13.6648 9.6H12.8V7.2H14.4V8.8696ZM11.2 10.4696C11.2 10.9112 10.9064 11.2 10.4648 11.2H5.6648C5.2224 11.2 4.8 10.9112 4.8 10.4696V1.6H11.2V10.4696ZM3.2 9.6H2.4648C2.0224 9.6 1.6 9.3112 1.6 8.8696V7.2H3.2V9.6ZM12.8 5.6V0H3.2V5.6H0V9.6696C0 10.5536 0.7808 11.2 1.6648 11.2H3.2648C3.2648 12 3.9808 12.8 4.8648 12.8H7.2V14.4H5.6V16H10.4V14.4H8.8V12.8H11.2648C12.148 12.8 12.8648 12 12.8648 11.2H14.4648C15.348 11.2 16 10.5536 16 9.6696V5.6H12.8Z"
        fill="#304A3D"
      />
    </svg>
  )
}

Mic.propTypes = {
  color: string,
  height: number,
  width: number,
}

export default Mic
